import arrowScroll from '../svg/arrow-scroll.svg';
import arrowScrollTwo from '../svg/arrow-scroll-two.svg';
import cardano from '../svg/cardano.svg';
import './styles/OpeningText.scss';
import Button from './Button';


function OpeningText() {


    return (
      <div className="openingText">
        <h1 className="titleH1">
          <span className="titleH1">Invest in DeFi,</span>redefine your
          yield
        </h1>
        <p className="desc1">
          A cross-chain borrowing and lending protocol for NFTs,
          liquidity positions, and synthetic assets, powered by the
          Cardano blockchain.
        </p>
        <div className="buttonsWrapper">
          <div className="button">
            <a
              className="button2 upText"
              href="https://t.me/paribus_io"
              target="blank"
            >
              Join Us
            </a>
          </div>
        </div>
        <div className="poweredMain">
          Powered By <img src={cardano} alt="" />
        </div>
      </div>
    )
}
            
export default OpeningText;


